import { Avatar, Group, Stack, Title, Text } from '@mantine/core';
import { BookingResponseModel } from '../../../../types/BookingModels';
import { getProfilePicture } from '../../../../types/UserDocument';
import { useMemo } from 'react';
import { format } from 'date-fns';

interface BookingPreviewProps {
  groupedBookings: BookingResponseModel[];
  bottomText?: string;
  title?: string;
  titleTestId?: string;
  textTestId?: string;
  bookingType?: 'incoming' | 'outgoing';
  profileId?: string;
  hideProfileButton?: boolean;
  booking?: BookingResponseModel;
}


export const BookingPreview: React.FC<BookingPreviewProps> = ({
  groupedBookings,
  bottomText,
  title,
  titleTestId,
  textTestId,
  bookingType: propBookingType,
  profileId,
}) => {
  const booking = groupedBookings[0];
  const finalBooking = groupedBookings[groupedBookings.length - 1];

  const bookingType = useMemo(() => {
    if (propBookingType) return propBookingType;
    if (profileId) return profileId === booking.userId ? 'outgoing' : 'incoming';
    return 'outgoing';
  }, [propBookingType, profileId, booking.userId]);

  const formattedTime = useMemo(() => {
    const start = new Date(booking.startIso);
    const end = new Date(finalBooking.endIso);
    return `${format(start, 'HH:mm')} - ${format(end, 'HH:mm')}`;
  }, [booking.startIso, finalBooking.endIso]);

  const formattedDate = useMemo(
    () => format(new Date(booking.startIso), 'EEE do MMM'),
    [booking.startIso]
  );

  const otherUserName = bookingType === 'outgoing' ? booking.professionalName : booking.userName;
  const otherUserProfilePicture = bookingType === 'outgoing' ? booking.professionalProfilePicture : booking.userProfilePicture;

  return (
    <>
      {title && (
        <Title order={3} fw="normal" ta="center" data-testid={titleTestId}>
          {title}
        </Title>
      )}
      <Stack gap={5} align="center" justify="center">
        <Avatar
          size={80}
          src={getProfilePicture(otherUserProfilePicture)}
        />
        <Title order={4} fw="bolder">
          {otherUserName}
        </Title>
        <Group gap={5}>
          <Text ta="center" c="dimmed">
            {formattedDate} |
          </Text>
          <Text ta="center" c="dimmed">
            {formattedTime}
          </Text>
        </Group>
      </Stack>
      <Text c="dimmed" size="sm" data-testid={textTestId}>
        {bottomText}
      </Text>
    </>
  );
};

